export default {
  name: 'marking--goods',
  apiService: 'shoes',
  apiPath: '/admin/goods',
};